'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useEffect, useState } from 'react';
import SvgTestTube from '../../../__generated__/icon/SvgTestTube';
interface TestMarkProps {
  stageKeyword?: string;
  devKeyword?: string;
}
const SESSION_KEY = 'test-mark';
export const TestMark = t0 => {
  const $ = _c(7);
  const {
    devKeyword: t1,
    stageKeyword: t2
  } = t0;
  const devKeyword = t1 === undefined ? "dev-" : t1;
  const stageKeyword = t2 === undefined ? "st-" : t2;
  const [isShow, setIsShow] = useState(false);
  const [env, setEnv] = useState();
  let t3;
  let t4;
  if ($[0] !== devKeyword || $[1] !== stageKeyword) {
    t3 = () => {
      const {
        origin
      } = location;
      const isHidden = sessionStorage.getItem(SESSION_KEY) === "hidden";
      if (!isHidden) {
        setIsShow(true);
      }
      setEnv(() => {
        if (origin.includes("localhost")) {
          return "local";
        }
        if (origin.includes(devKeyword)) {
          return "dev";
        }
        if (origin.includes(stageKeyword)) {
          return "stage";
        }
      });
    };
    t4 = [devKeyword, stageKeyword];
    $[0] = devKeyword;
    $[1] = stageKeyword;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== env || $[5] !== isShow) {
    t5 = isShow && env ? <button className={cn("fixed left-10 top-10 z-50 rounded-pill p-5 opacity-50", {
      "bg-R-500": env === "dev",
      "bg-Y-500": env === "stage",
      "bg-B-500": env === "local"
    })} type="button" aria-label={`테스트 환경 표시 닫기 (${env})`} onClick={() => {
      setIsShow(false);
      sessionStorage.setItem(SESSION_KEY, "hidden");
    }}><SvgTestTube className="size-15 text-Gray-50" name="Test-Tube" /></button> : null;
    $[4] = env;
    $[5] = isShow;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};